export class QueryParameters {

    static getObject(): any {
        let queryStringObject: any = {};
        let queryParameters = window.location.href.split("?");
        if (queryParameters.length > 0) {
            let queryString = queryParameters[1];
            if (queryString !== undefined && queryString !== null) {
                queryStringObject = JSON.parse('{"' + queryString.replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
            }
        }
        return queryStringObject;
    }
}